import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";
import format from "date-fns/format";
import FileSaver from "file-saver";

export default makeListingMixin(
	"listingUser",
	api.listingUsers
)({
	actions: {
		async listingUserExport(context, { id, title }) {
			try {
				// 1. call the api call for exporting listing users
				const csv = await api.exportListingUsers(id);

				// 2. create the filename for downloading
				title = title.replace(/\s+/g, "-").toLowerCase();
				const date = format(new Date(), "ddMMyyyy_HHmmss");
				const filename = `${title}-users-${date}.csv`;

				const csvFile = new Blob([csv], {
					type: "text/csv;charset=utf-8"
				});

				FileSaver.saveAs(csvFile, filename);
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// console.log(context);
		}
	}
});
